import React, { useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import get from "lodash/get";

import OkAnalytics from "analytics/util/Analytics";
import ClientStats from "shared/util/ClientStats";
import Context from "shared/util/Context";
import _str from "shared/util/_str";
import _strf from "shared/util/_strf";
import Masthead from "./Masthead";
import { ROUTES } from "routers/shared/util/consts";

const QUERY = gql`
	query IntoYouMasthead($userid: String!) {
		user(id: $userid) {
			id
			notificationCounts {
				likesIncoming
			}
		}
	}
`;

const IntoYou = React.forwardRef((_, ref) => {
	const { data, loading } = useQuery(QUERY, {
		variables: {
			userid: Context.get("userid"),
		},
	});
	const incomingLikeCount = get(data, "user.notificationCounts.likesIncoming");

	useEffect(() => { ClientStats.update("masthead - intoyou2 - shown"); }, []);
	const onClose = () => ClientStats.update("masthead - intoyou2 - closed");

	if (loading) {
		return null;
	}

	return (
		<Masthead ref={ref} id="alist_intoyou_masthead" className="intoyou opensans alistpromo" onClose={onClose}>
			<div className="image" />
			<div className="text">
				<p>
					{_strf("Hey, $username,", {
						username: Context.get("displayname") || _str("good news"),
					})}&nbsp;
					<strong>{_strf("$numvotes people like you!", { numvotes: incomingLikeCount })}</strong>
				</p>
				<p>{_str("See everyone who likes you with A-List.")}</p>
			</div>
			<div className="button">
				<a href={`${ROUTES.Upgrade[0]}?feature=intoyou&cf=desktopbanner`} className="flatbutton big" onClick={() => OkAnalytics.Promos.trackLikesYouUpsellHeaderPromo(incomingLikeCount)}>
					{_str("Learn more")}
				</a>
			</div>
		</Masthead>
	);
});

export default IntoYou;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/IntoYou.jsx